import Header from '../components/Header';
import HamburgerMenu from '../components/HamburgerMenu';
import profile from '../assets/profile_picture.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faCircleUser, faFolder } from "@fortawesome/free-solid-svg-icons";
import '../styles/Header.css';
import { useApp } from '../context/AppContext';

const Home = () =>{
    const {menuActive, toggleMenu} = useApp();

    return (
        <div className="App">
            <Header setOpenMenu={toggleMenu}></Header>
            <main className='profile-dev'>
                <section className='profile-dev__info'>
                <div>
                    <p className='text-body'>Bienvenido a mi sitio web mi nombre es </p>
                    <p className='text-title'>George Muñoz</p>
                    <h2 className='text-subtitle'>Frontend Developer</h2>
                    <p className='text-body'>Soy desarrollador con 3 años de experiencia en desarrollo web, trabajando con las tecnologías HTML, CSS, Java Script, PHP y React. Busco colaborar en una posición como Desarrollador Frontend. Me caracterizó por mantener un aprendizaje continuo, mejorar mis habilidades, ser autodidacta, colaboración en equipo y abierto a retroalimentación.</p>
                    <div className="header-links_body">
                    <a href="https://github.com/geomunioz" className="btn-link">
                        <FontAwesomeIcon icon={faGithub} />
                    </a>
                    <a href="https://www.linkedin.com/in/geomunioz/" className="btn-link">
                        <FontAwesomeIcon icon={faLinkedin} />
                    </a>
                    </div>
                </div>
                </section>
                <section className='profile-dev__picture'>
                    <picture>
                        <img src={profile} alt="George Muñoz" />
                    </picture>
                </section>
            </main>
            <section className='btn-footer'>
                <a className='btn-principal' href='/about'>
                Acerca de <FontAwesomeIcon icon={faCircleUser}></FontAwesomeIcon>
                </a>
                <a className='btn-principal' href='/projects'>
                Proyectos <FontAwesomeIcon icon={faFolder}></FontAwesomeIcon>
                </a>
            </section>
            <HamburgerMenu isOpenMenu={menuActive} setOpenMenu={toggleMenu}></HamburgerMenu>
        </div>
    );
}

export default Home;